/* import customSelect from 'custom-select';
customSelect('select'); */

// Select language
const changeLanguageHandler = (e) => {
    const target = e.currentTarget,
        targetVal = target.value;
    window.location.href = targetVal;

};

const langSwitcher = document.querySelector('.lang-select');
if(langSwitcher) {
    langSwitcher.addEventListener('change', changeLanguageHandler);
};
